import { Link } from 'react-router'
import { STATES } from '../content/states'

const productLinks = [
  { label: 'Features', to: '/features' },
  { label: 'Pricing', to: '/pricing' },
  { label: 'Coverage Map', to: '/coverage' },
  { label: 'How It Works', to: '/how-it-works' },
  { label: 'Contractor Guides', to: '/guides' },
]

export default function Footer() {
  return (
    <footer id="footer" className="bg-[#0d1117] border-t border-white/[0.06]">
      <div className="max-w-[1280px] mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="text-xl font-semibold tracking-tight">
              <span className="text-white">Procur</span>
              <span className="text-[#ef4444]">Alerts</span>
            </Link>
            <p className="mt-3 text-sm text-[#9ca3af] leading-relaxed">
              Bid intelligence for New England contractors.
            </p>
          </div>

          {/* Product */}
          <div>
            <h2 className="text-xs font-mono uppercase tracking-[0.08em] text-white mb-4">
              Product
            </h2>
            <ul className="space-y-3">
              {productLinks.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200 relative group"
                  >
                    {link.label}
                    <span className="absolute bottom-0 left-0 w-0 h-px bg-[#06b6d4] transition-all duration-200 group-hover:w-full" />
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href="https://app.procuralerts.com/bids"
                  className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200 relative group"
                >
                  Browse Live Bids
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-[#06b6d4] transition-all duration-200 group-hover:w-full" />
                </a>
              </li>
            </ul>
          </div>

          {/* Keep every evergreen state hub within one crawlable link of every
              marketing page. */}
          <div>
            <h2 className="text-xs font-mono uppercase tracking-[0.08em] text-white mb-4">
              Government bids
            </h2>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/government-bids"
                  className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200"
                >
                  All of New England
                </Link>
              </li>
              {STATES.map((state) => (
                <li key={state.slug}>
                  <Link
                    to={`/government-bids/${state.slug}`}
                    className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200"
                  >
                    {state.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-xs font-mono uppercase tracking-[0.08em] text-white mb-4">
              Contact
            </h2>
            <ul className="space-y-3">
              <li>
                <a
                  href="mailto:hello@procuralerts.com"
                  className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200 relative group"
                >
                  hello@procuralerts.com
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-[#06b6d4] transition-all duration-200 group-hover:w-full" />
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h2 className="text-xs font-mono uppercase tracking-[0.08em] text-white mb-4">
              Legal
            </h2>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms"
                  className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200 relative group"
                >
                  Terms of Service
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-[#06b6d4] transition-all duration-200 group-hover:w-full" />
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-[#9ca3af] hover:text-[#06b6d4] transition-colors duration-200 relative group"
                >
                  Privacy Policy
                  <span className="absolute bottom-0 left-0 w-0 h-px bg-[#06b6d4] transition-all duration-200 group-hover:w-full" />
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider + Legal row */}
        <div className="mt-10 pt-8 border-t border-white/[0.06] flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="text-[10px] font-mono text-[#9ca3af] tracking-[0.04em]">
            &copy; 2026 ProcurAlerts. All rights reserved.
          </span>
          <a
            href="mailto:hello@procuralerts.com"
            className="text-[10px] font-mono text-[#9ca3af] hover:text-[#06b6d4] transition-colors tracking-[0.04em]"
          >
            hello@procuralerts.com
          </a>
          <span className="text-[10px] font-mono text-[#9ca3af] tracking-[0.04em]">Bid intelligence across all 6 New England states</span>
        </div>
      </div>
    </footer>
  )
}
